export const actions = {
  editar: 'editar',
  confirmar: 'confirmar',
  alterarValor: 'alterarValor',
  cancelarModal: 'cancelarModal',
  gravarValor: 'gravarValor',
  alterarLoading: 'alterarLoading',
  reiniciarValores: 'reiniciarValores',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.editar:
      return { ...state, editando: true };
    case actions.confirmar:
      return {
        ...state,
        mostrarModalConfirmacao: state.hourlyRate !== state.valorHoraInicial,
        editando: state.hourlyRate !== state.valorHoraInicial,
      };
    case actions.alterarValor:
      return { ...state, hourlyRate: action.hourlyRate };
    case actions.reiniciarValores:
      return { ...state, hourlyRate: action.hourlyRate, valorHoraInicial: action.hourlyRate };
    case actions.cancelarModal:
      return {
        ...state,
        hourlyRate: state.valorHoraInicial,
        editando: false,
        mostrarModalConfirmacao: false,
      };
    case actions.gravarValor:
      return {
        ...state,
        editando: false,
        mostrarModalConfirmacao: false,
        valorHoraInicial: action.hourlyRate,
        hourlyRate: action.hourlyRate,
      };
    case actions.alterarLoading:
      return { ...state, loading: action.loading };
    default:
      throw new Error();
  }
};
